/**
 * PlatformRoute — restringe uma rota da área interna ao escritório-plataforma. // ux-neutrality:allow doc-comment
 *
 * Enquanto o perfil resolve, segura a rota; usuário não-plataforma é // ux-neutrality:allow doc-comment
 * redirecionado (fail-closed). O backend continua sendo a autoridade real (403). // ux-neutrality:allow doc-comment
 *
 * E70.F1: falha ao LER o perfil não é recusa — vira o estado de erro com // ux-neutrality:allow doc-comment
 * "tentar novamente", que zera o cache e remonta o guard para refazer o fetch. // ux-neutrality:allow doc-comment
 */
import { type ReactElement, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { resetCurrentRoleCache, useCurrentRole } from '@/lib/auth/useCurrentRole';
import { GuardIndisponivel } from './GuardIndisponivel';

function Guard({ children, onRetry }: { children: ReactElement; onRetry: () => void }) {
  const { isPlatform, loading, error } = useCurrentRole();
  if (loading) {
    return <div data-testid="platform-guard-loading" />;
  }
  if (error) {
    return <GuardIndisponivel onRetry={onRetry} />;
  }
  if (!isPlatform) {
    return <Navigate to="/403" replace />;
  }
  return children;
}

export function PlatformRoute({ children }: { children: ReactElement }): ReactElement {
  const [tentativa, setTentativa] = useState(0);
  const retry = () => {
    resetCurrentRoleCache();
    setTentativa((atual) => atual + 1);
  };
  return (
    <Guard key={tentativa} onRetry={retry}>
      {children}
    </Guard>
  );
}
